export const CONTROLS_LAYER = 30;
export const HIGHLIGHTED_EDGE = 100;
